import styled from '@emotion/styled';
import { FoilTag } from 'cards/components/common/Tags/FoilTag';
import { LetterpressTag } from 'cards/components/common/Tags/LetterpressTag';

export const SuiteNameContainer = styled.div`
  margin: 12px -4px 4px;
  padding-left: 12px;

  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;

  text-shadow: none;

  > div,
  h6 {
    margin: 4px;
  }
`;

export const CardName = styled.h6`
  font-family: ${props => props.theme.FONTS.FONT_FAMILY_PROXIMA};
  font-weight: ${props => props.theme.FONTS.FONT_WEIGHT_SEMI_BOLD};
  font-size: ${props => props.theme.FONTS.FONT_SIZE_SMALL};
  letter-spacing: 0;

  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledFoilTag = styled(FoilTag)`
  box-shadow: none;
  margin-left: 8px;
  padding: 0 8px;

  > div {
    color: #21201f;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    text-shadow: none;
  }
`;

export const StyledLetterpressTag = styled(LetterpressTag)`
  background-color: #55a1bf33 !important;
  box-shadow: none;
  padding: 0 8px;

  > div {
    color: #55a1bf;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    text-shadow: none;
  }
`;
